import { render, staticRenderFns } from "./InitialSection.vue?vue&type=template&id=773a0183&"
import script from "./InitialSection.vue?vue&type=script&lang=js&"
export * from "./InitialSection.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/codebuild/output/src1477836768/src/github.com/FebosIO/Febos-AMI/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('773a0183')) {
      api.createRecord('773a0183', component.options)
    } else {
      api.reload('773a0183', component.options)
    }
    module.hot.accept("./InitialSection.vue?vue&type=template&id=773a0183&", function () {
      api.rerender('773a0183', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/febos/aduanas/batches/views/components/InitialSection.vue"
export default component.exports